import { useMemo } from 'react';
import {
	getInitialComposeValues,
	normalizeRecipient,
} from '@/components/Drawers/AddUnlayerEmailDrawer/helpers';
import { getDealClientId } from '@/features/deals/helper';

export const useUnlayerComposePresets = ({ params, clientRow, dealRow, dialogData }) => {
	const activeDealId = params?.dealId ?? dealRow?.dealId ?? null;
	const hasClientContext =
		Boolean(params?.clientId) || Boolean(clientRow) || Boolean(getDealClientId(dealRow));

	const contextPresetClient = useMemo(
		() => (hasClientContext && clientRow ? clientRow : null),
		[clientRow, hasClientContext],
	);
	const contextPresetDeal = useMemo(
		() => (activeDealId ? (dealRow ?? null) : null),
		[dealRow, activeDealId],
	);
	const presetClient = useMemo(
		() => dialogData?.client ?? contextPresetClient ?? null,
		[contextPresetClient, dialogData?.client],
	);
	const presetDeal = useMemo(
		() => dialogData?.deal ?? contextPresetDeal ?? null,
		[contextPresetDeal, dialogData?.deal],
	);
	const presetRecipient = useMemo(() => normalizeRecipient(presetClient), [presetClient]);
	const presetRecipients = useMemo(
		() => (presetRecipient ? [presetRecipient] : []),
		[presetRecipient],
	);
	const presetSubject = useMemo(() => dialogData?.subject ?? '', [dialogData?.subject]);
	const presetEditorHtml = useMemo(() => dialogData?.editorHtml ?? '', [dialogData?.editorHtml]);
	const presetEditorDesign = useMemo(
		() => dialogData?.editorDesign ?? null,
		[dialogData?.editorDesign],
	);
	const initialValues = useMemo(
		() =>
			getInitialComposeValues({
				presetClient,
				presetDeal,
				presetRecipients,
				presetSubject,
				presetEditorHtml,
				presetEditorDesign,
			}),
		[
			presetClient,
			presetDeal,
			presetRecipients,
			presetSubject,
			presetEditorHtml,
			presetEditorDesign,
		],
	);

	return {
		initialValues,
		presetClient,
		presetDeal,
	};
};
